import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { PrivateRoute } from './Components/PrivateRoute'
import mainRouter from './route/main.js'
import { createBrowserHistory } from 'history';
import { ThemeProvider, createMuiTheme } from '@material-ui/core';
export const history = createBrowserHistory();


const baseTheme = createMuiTheme();


class App extends React.Component {

    render() {
        return (
            <ThemeProvider theme={baseTheme}>
                <Router history={history}>
                    <Switch>
                        {

                            mainRouter.map((prop, key) => {
                                return prop.isPrivate ?
                                    (<PrivateRoute exact={prop.exact} path={prop.path} component={prop.component} key={key} />) :
                                    (<Route exact={prop.exact} path={prop.path} component={prop.component} key={key} />)
                            })
                        }
                    </Switch>
                </Router>
            </ThemeProvider>
        )
    }
}

export default App;